import { z } from 'zod';

export const CheckAnswerInputSchema = z.object({
  story: z.string(),
  question: z.string(),
  receivedAnswer: z.string(),
  prototypeAnswer: z.string(),
});

export type CheckAnswerInputType = z.infer<typeof CheckAnswerInputSchema>;

export interface CheckAnswerResult {
  isCorrect: boolean;
}
